import { useCallback, useEffect, useState } from 'react';

import { ApiGet, ApiPostNew } from '../services/apiService';
import ChartContainer from './graficos/ChartContainer';
import { GraficoBarraSubArea } from './graficos/GraficoBarraSubArea';

export const Modal4 = ({ OpcoesSequencial }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const pastDate = new Date();
  pastDate.setMonth(currentDate.getMonth() - 3);
  const pastYear = pastDate.getFullYear();
  const pastMonth = pastDate.getMonth() + 1;

  const formatDate = (year, month) => {
    return `${year}${month.toString().padStart(2, '0')}`;
  };

  const initialDataInicial = formatDate(pastYear, pastMonth);
  const initialDataFinal = formatDate(currentYear, currentMonth);

  const [seq, setSeq] = useState(['00019']);
  const [dataInicial, setDataInicial] = useState(initialDataInicial);
  const [dataFinal, setDataFinal] = useState(initialDataFinal);
  const [graficoLinha, setGraficoLinha] = useState([]);
  const [metaSubArea, setMetaSubArea] = useState({});

  const prevSeqOptions = OpcoesSequencial.slice().sort((a, b) =>
    a.que_descri.localeCompare(b.que_descri)
  );

  const seqOptions = prevSeqOptions.map((option, index) => {
    return { item: `${option.que_seqque} - ${option.que_descri}` };
  });

  const handleSearch = useCallback(async () => {
    try {
      let useSeq;
      if (!seq) {
        useSeq = prevSeqOptions[0].que_seqque;
      } else {
        useSeq = seq;
      }

      const response = await ApiPostNew(
        '/auditoria/grafico/media/s/mes',
        {
          seq: useSeq,
          dateIni: dataInicial,
          dateFim: dataFinal
        },
        localStorage.getItem('sessionToken')
      );
      const subarea = await ApiGet(
        '/tabela/subarea',
        {},
        localStorage.getItem('sessionToken')
      );
      let metaSubArea = subarea.data.tabela.reduce((acc, curr) => {
        if (curr.sar_pesosar !== null) {
          acc[curr.sar_descri] = curr.sar_pesosar;
        }
        return acc;
      }, {});
      setMetaSubArea(metaSubArea);
      // setMetaSubArea({
      //   '4 S - PADRONIZAÇÃO': 20,
      //   '2 S - ARRUMAÇÃO': 10,
      //   '5 S - DISCIPLINA': 10,
      //   '1 S - ORGANIZAÇÃO': 20,
      //   '3 S - LIMPEZA': 20
      // });
      const newData = response.data?.auditoria?.map((item) => ({
        data_id: item.anomes,
        sequencial_id: item.sar_codsar,
        sequencial_descricao: item.sar_descri,
        quantidade: item.qt_aplicacoes,
        soma_notas: item.soma_nota_subarea,
        media: item.media_nota_subarea
      }));
      return newData || [];
    } catch (err) {
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seq, dataInicial, dataFinal]);

  useEffect(() => {
    handleSearch().then((data) => {
      setGraficoLinha(data);
    });
  }, [handleSearch]);

  return (
    <>
      <div
        className="modal fade modal-xl"
        id="ModalGrafico4"
        tabIndex="-1"
        aria-labelledby="lblGrafico1"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-scrollable modalDialog">
          <div className="modal-content">
            <div className="modal-header" style={{ height: '3rem' }}>
              <div className="d-flex justify-content-botween align-items-center w-100">
                <i
                  className="fa-solid fa-arrow-left fs-5"
                  data-bs-toggle="modal"
                  data-bs-target="#ModalLista"
                ></i>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
            </div>

            <ChartContainer
              seqOptions={seqOptions}
              setSeq={setSeq}
              dataInicialFormatted={String(dataInicial)}
              dataFinalFormatted={String(dataFinal)}
              setDataInicial={setDataInicial}
              setDataFinal={setDataFinal}
              isMany={true}
            >
              <GraficoBarraSubArea
                data={graficoLinha}
                metaSubArea={metaSubArea}
                mesIni={String(dataInicial).slice(4, 6)}
                anoIni={String(dataInicial).slice(0, 4)}
                mesFim={String(dataFinal).slice(4, 6)}
                anoFim={String(dataFinal).slice(0, 4)}
                titulo={
                  'Media da Empresa dos S por mês das Notas das aplicação no periodo'
                }
              />
            </ChartContainer>
          </div>
        </div>
      </div>
    </>
  );
};
